import { IconButton } from '@mui/material'
// eslint-disable-next-line import/no-unresolved
import Sun from '../../assets/illustrations/Bredbånd/sun-white.svg?react'
// eslint-disable-next-line import/no-unresolved
import Moon from '../../assets/illustrations/Bredbånd/moon.svg?react'

interface Props {
  checked: boolean
  onChange: () => void
}

const ThemeToggle = ({ checked, onChange }: Props) => {
  return <IconButton onClick={onChange}>{checked ? <Sun /> : <Moon />}</IconButton>
}

export default ThemeToggle
